module.exports = __webpack_public_path__ + "static/img/17.1e345b47.gif";